import { render, staticRenderFns } from "./SettingsUser.vue?vue&type=template&id=9a6fbae6&scoped=true"
import script from "./SettingsUser.vue?vue&type=script&lang=js"
export * from "./SettingsUser.vue?vue&type=script&lang=js"
import style0 from "./SettingsUser.vue?vue&type=style&index=0&id=9a6fbae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6fbae6",
  null
  
)

export default component.exports